import React, { Component } from "react";
import { Container } from "reactstrap";
import { connect } from "react-redux";
import FormCatalogoCobro from "./FormCatalogoCobro";
import { getCatalogoCobroDetail, putCatalogoCobroUpdate } from "./CatalogoCobroAction";
import swal from "sweetalert";
import { withRouter } from 'react-router-dom';

import SweetAlert from 'sweetalert2-react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TabContent, TabPane, Nav, NavLink, NavItem } from "reactstrap";
import classnames from 'classnames';
import Dropzone from '../../common/DropzoneExample';
import { Link } from "react-router-dom";


const mapStateToProps = (state) => {
    return {
        getResponDataCatalogoCobro: state.CatalogoCobroReducer.getResponDataCatalogoCobro,
        errorResponDataCatalogoCobro: state.CatalogoCobroReducer.errorResponDataCatalogoCobro,
    };
};

class CatalogoCobroEditContainer extends Component {

	constructor(props) {
		super(props);
		this.state = {
			activeTab: 1,
			show: false,
		};
	}

    componentDidMount() {
        this.props.dispatch(getCatalogoCobroDetail(this.props.match.params.id));
    }

    handleSubmit(data) {
        this.props.dispatch(putCatalogoCobroUpdate(data, this.props.match.params.id));
    }

	render() {
		const { activeTab } = this.state

		if (this.props.getResponDataCatalogoCobro || this.props.errorResponDataCatalogoCobro) {

			if (this.props.errorResponDataCatalogoCobro || (this.props.getResponDataCatalogoCobro != "OK")) {
				swal({
					title: this.props.getResponDataCatalogoCobro,
					icon: "error",
					button: "Enterado"
				}
				).then((willDelete) => {
					this.props.history.push("/servicios");
				});
            } else {
				swal({
					title: "¡Servicio Actualizado!",
					icon: "success",
					button:"Enterado"
					}
                )
                .then((willDelete) => {
					this.props.history.push("/servicios");
                });
			}//END ELSE

        }//END IF

		return (
			<>
				<div className="section-body">
					<div className="container-fluid">
						<div className="d-flex justify-content-between align-items-center ">
							<div className="header-action">
								<h1 className="page-title">Servicios</h1>
								<ol className="breadcrumb page-breadcrumb">
									<li className="breadcrumb-item"><a href="#">Administrativo</a></li>
									<li className="breadcrumb-item active" aria-current="page">Editar</li>
								</ol>
							</div>
							<Nav tabs className="page-header-tab">
								<NavItem>
									<Link to={"/servicios"}>Listar Servicios</Link>
								</NavItem>
							</Nav>

						</div>
					</div>
				</div>

				<div className="section-body mt-4">
					<div className="container-fluid">
						<TabContent activeTab={activeTab}>

							<TabPane tabId={1} className={classnames(['fade show'])}>
								

								<div className="row clearfix">
									<div className="col-lg-12 col-md-12 col-sm-12">
										<div className="card">
											<div className="card-header">
												<h3 className="card-title">Editar Servicios IEC</h3>
												<div className="card-options ">
													<a href="#" className="card-options-collapse" data-toggle="card-collapse"><i className="fe fe-chevron-up"></i></a>
													<a href="#" className="card-options-remove" data-toggle="card-remove"><i className="fe fe-x"></i></a>
												</div>
											</div>

											<FormCatalogoCobro onSubmit={(data) => this.handleSubmit(data)} />

										</div>
									</div>

								</div>

							</TabPane>


						</TabContent>
					</div>
				</div>

			</>
		);

    }// END RENDER

} //END CatalogoCobroEditContainer

export default withRouter(connect(mapStateToProps, null)(CatalogoCobroEditContainer));
